import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { store } from '@/store'
import CustomPersistGate from '@/components/PersistGate'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <CustomPersistGate>
        <App />
      </CustomPersistGate>
    </Provider>
  </StrictMode>,
)
